// extracted by mini-css-extract-plugin
export default {"ctaContainer":"FAQRedirect_ctaContainer__U20Yw","textContent":"FAQRedirect_textContent__OOUGc","ctaButton":"FAQRedirect_ctaButton__4V4A0"};